import { Component, OnInit } from '@angular/core';
import { paths } from 'src/app/Shared/enums/paths.enum';
import { CommonService } from 'src/app/Shared/services/common_services/common.service';
import { DataCommunicationService } from 'src/app/Shared/services/data_service/data-communication.service';
import { LoaderindicatorService } from 'src/app/Shared/services/loaderindicator/loaderindicator.service';

@Component({
  selector: 'mgfw-dealer-selection',
  templateUrl: './dealer-selection.component.html',
  styleUrls: ['./dealer-selection.component.css']
})
export class DealerSelectionComponent implements OnInit {

  param = {UserID:0,Brand:'Mitsubishi'}
  dealerList = [];
  dealerGroupByCounty = []
  selectedDealer = null;
  constructor(
    private commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    private readonly loadingIndicatorService: LoaderindicatorService,
  ) { }

  ngOnInit() {
    this.commonService.clearLocalStorage();
    this.commonService.setLocalStorage("AppointmentSource","Mitsubishi");
    this.getAllDealers();
  }

  getAllDealers(){
    this.dataCommunicationService.getDealerList(this.param).subscribe(result=>{
      this.dealerList = [];
      if(result.StatusCode === 1){
        this.dealerList = result.Data;
        var County = this.dealerList.map(item => item.County).filter((value, index, self) => self.indexOf(value) === index)
        delete County[County.indexOf(null)]
        County.forEach(element => {
          this.dealerGroupByCounty.push({'County':element,'Dealers':this.dealerList.filter(x=>x.County == element)})
        });        
      }
      
    })
  }

  selectDealer(id){
    this.selectedDealer =  this.dealerList.find(x=>x.DealerNo == id);
  }

  redirect(){
    this.commonService.setLocalStorage("SelectedDealerName",this.selectedDealer.Name);
    this.commonService.NavigatePage(paths.BOOKAPPOINTMENT,this.selectedDealer.DealerAliasName,'Mitsubishi');
    
  }

}
